import { spiritoryWebApi } from '@/lib/axios/SpiritoryWebApi/spiritoryWebApi';

export default async function doSendPasswordReset(email: string, locale?: string) {
  await spiritoryWebApi.post('/auth/reset-password/send', { email, locale }, undefined);
}
